import React, {useEffect, useState} from "react";
import {Box, Container, Paper, Tabs, Tab, Typography} from "@mui/material";
import ContactAndFAADetails from "./ContactAndFAADetails";
import BillingDetails from "./BillingDetails";
import EmailPreferences from "./EmailPreferences";
import ProfileStyles from "../../styles/userProfile.module.css";
import {useProfile} from "../../context/userContext";
import {useAuth} from "../../context/authContext";
import {useSearchParams} from "react-router-dom";
import {useOrganization} from "../../context/OrganizationContext";

const ProfilePage = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const {profile: initialProfile} = useProfile();
    const [profile, setProfile] = useState(initialProfile); // Manage profile state locally
    const {authenticated, token} = useAuth();
    const {isInOrganizationMode} = useOrganization();

    // Get tab from URL or default to 0
    const getTabFromUrl = () => {
        const tab = searchParams.get('tab');
        // Don't allow billing tab for organization users
        if (tab === 'billing' && isInOrganizationMode) {
            return 0;
        }
        return tab === 'billing' ? 1 : 0;
    };

    const [activeTab, setActiveTab] = useState(getTabFromUrl());

    useEffect(() => {
        setActiveTab(getTabFromUrl());
    }, [searchParams]);


    const handleTabChange = (event, newValue) => {
        // For organization users, only contact tab exists (index 0)
        // For individual users, billing is index 1
        const tab = newValue === 1 && !isInOrganizationMode ? 'billing' : 'contact';
        setSearchParams({ tab });
        setActiveTab(newValue);
    };

    const onUpdateProfile = (updatedProfile) => {
        setProfile(updatedProfile); // Update the profile state
    };

    return (
        <Container maxWidth="lg">
            <Paper className={ProfileStyles.profile_container} elevation={3}>
                <Box className={ProfileStyles.profile_header}>
                    <Typography mt={2} variant="h4" gutterBottom>
                        Profile Settings
                    </Typography>
                </Box>

                <Tabs
                    value={activeTab}
                    onChange={handleTabChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="fullWidth"
                >
                    <Tab label="Contact & FAA Details"/>
                    {!isInOrganizationMode && <Tab label="Billing Information"/>}
                    {/*<Tab label="Email Preferences" />*/}
                </Tabs>

                <Box mt={3}>
                    {activeTab === 0 && <ContactAndFAADetails token={token} onUpdateProfile={onUpdateProfile}/>}
                    {activeTab === 1 && !isInOrganizationMode && <BillingDetails/>}
                    {/*{activeTab === 2 && <EmailPreferences profile={profile} />}*/}
                </Box>
            </Paper>
        </Container>
    );
};

export default ProfilePage;